// eslint-disable-next-line simple-import-sort/imports
import { Flex, Image, Loader, Text } from '@mantine/core'
import { CredentialResponse, GoogleLogin } from '@react-oauth/google'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { VITE_ENVIRONMENT } from '@/utils/constants'
// eslint-disable-next-line import/no-unresolved
import WhiteLogo from '/White-Logo.png'

import { EmmaPath } from '../router/paths'
import { useAuth } from './use-auth'

export const SignIn = () => {
  const { isAuthenticated, onGoogleSuccess } = useAuth()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const onLocalSuccess = (credentialResponse: CredentialResponse) => {
    setIsLoading(true)
    onGoogleSuccess(credentialResponse)
      .then(() => {
        console.debug('Local success')
        setIsLoading(false)
        navigate(EmmaPath.EMMA, { replace: true })
      })
      .catch(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    if (isAuthenticated) {
      if (VITE_ENVIRONMENT === 'prod') {
        navigate(EmmaPath.REPORT_SALES, { replace: true })
      } else {
        navigate(EmmaPath.EMMA, { replace: true })
      }
    }
  }, [isAuthenticated])

  if (isLoading) {
    return <Loader />
  }

  return (
    <Flex mih="100vh" direction="column" justify="center" align="center" bg="#27343D">
      <Flex direction="column" gap={60} justify="center" align="center">
        <Image
          src={WhiteLogo}
          className="dark:drop-shadow-[0_0_0.3rem_#ffffff70]"
          alt="Einstein Logo"
          w={180}
          h={180}
        />
        <GoogleLogin
          onSuccess={onLocalSuccess}
          onError={() => {
            setError('Login Failed')
          }}
        />
        {!!error && (
          <Text
            c="white"
            fz="md"
            style={{ background: 'white', borderRadius: '4px', color: 'red', marginTop: '8px', padding: '8px' }}
          >
            {error}
          </Text>
        )}
      </Flex>
    </Flex>
  )
}
